module.exports = {"content":{},"productInfo":{"code":"{EE2FB87A-BE71-4FF0-B805-BDEBB4F57146}","name":"ベトナム語　初中級","serialHead":"NBNTS","courseResourceIDs":[{"levelNo":1,"resourceID":"222ae68271eb4fc1b15a811bd3ac1607dee35c6a"},{"levelNo":2,"resourceID":"47c34a16eb8abbbf26b4e416c8599242bb68bcc8"},{"levelNo":3,"resourceID":"401a6c535f3c3e0d05f266ff38587e2b541b1d12"}],"language":"vi-VN","challengeCount":21326},"version":"1.1.0"}


//////////////////
// WEBPACK FOOTER
// ./static/data.json
// module id = 207
// module chunks = 1